import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=aeda8144&scoped=true&"
import script from "./VideoList.vue?vue&type=script&lang=ts&"
export * from "./VideoList.vue?vue&type=script&lang=ts&"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=aeda8144&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeda8144",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VImg,VSimpleTable})
